// extracted by mini-css-extract-plugin
export default {"progress-step-prefix":"UEkIVb","progressStepPrefix":"UEkIVb","progress-step-label":"SuHoKY","progressStepLabel":"SuHoKY"};